import api from '../api/axios';

function buildParams({ startDate, endDate, employeeId, metric } = {}) {
  const params = {
    startDate,
    endDate,
  };
  if (employeeId) params.employeeId = employeeId;
  if (metric) params.metric = metric;
  return params;
}

export const getEmployeeWorkSummary = (filters = {}) =>
  api.get('/api/admin/employee-work-summary', { params: buildParams(filters) }).then((r) => r.data);
